<template>
  <Message v-if="newPasswordSaved">
    <template v-slot:content>
      <v-card class="elevation-0 pa-3">
        <v-card-text>
          <div class="layout column align-center">
            <v-img src="@/assets/images/Blu.png" alt="Blú Capital" width="180" height="180"/>
            <h1 class="flex my-4 accent--text text-center" >Contraseña Actualizada</h1>
            <h2 class="flex my-4 accent--text text-center">
            Tu contraseña ha sido reestablecida correctamente</h2>
            <v-btn class="font-weight-black" rounded block color="#5B9DF2" dark @click="goToLogin()">Iniciar Sesión</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </template>
  </Message>
  <v-flex xs12 sm8 md4 lg4 v-else>
    <v-card class="elevation-8 pa-3">
      <v-card-text>
        <div class="layout column align-center">
          <v-img src="@/assets/images/Blu.png" alt="Blú Capital" width="180" height="180"/>
          <h1 class="flex my-4 accent--text text-center">Escribe tu nueva contraseña</h1>
        </div>
        <v-form
          ref="formNewPassword"
          v-model="isValid"
          lazy-validation
          >
          <v-text-field
          label="Correo Electrónico"
          disabled
          name="username"
          v-model="email"
          prepend-icon="mdi-email"
          type="text"
          />
          <v-text-field
          id="password1"
          label="Nueva Contraseña"
          name="password"
          v-model="password"
          prepend-icon="mdi-lock"
          type="password"
          :rules="passwordRules"
          required
          />
          <v-text-field
          id="password2"
          label="Repite la nueva contraseña"
          name="password"
          v-model="password2"
          prepend-icon="mdi-lock"
          type="password"
          :rules="passwordRules"
          required
          />
        </v-form>
      </v-card-text>
      <v-card-text>
        <v-btn class="font-weight-black" rounded block color="#5B9DF2" dark @click="setNewPassword()">Guardar nueva contraseña</v-btn>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import SessionService from '@/services/SessionService'
import Message from '@/components/Profile/Message.vue'

export default {
  name: 'ChangePassword',
  props: ['email', 'userKey'],
  components: { Message },
  data () {
    return {
      isValid: true,
      newPasswordSaved: false,
      password: '',
      password2: '',
      passwordRules: [
        v => !!v || 'La contraseña es requerida',
        v => (v || '').indexOf(' ') < 0 || 'Los espacios no están permitidos',
        v => (!!v && v) === this.password || 'Las contraseñas no coinciden',
        v => (v && v.length > 7) || 'La contraseña debe tener mínimo 8 caracteres'
      ]
    }
  },
  methods: {
    goToLogin () {
      this.$router.push({
        name: 'login',
        query: {
          email: this.email
        }
      })
    },
    validatePassword () {
      this.isValid = false
      if (this.$refs.formNewPassword.validate()) {
        this.isValid = true
      }
    },
    async setNewPassword () {
      await this.validatePassword()
      if (this.isValid) {
        const loader = this.$loading.show()
        try {
          const record = {
            email: this.email,
            password: this.password,
            recoverPassKey: this.userKey
          }

          await SessionService.setNewPassword(record)
          loader.hide()
          this.newPasswordSaved = true
        } catch (error) {
          loader.hide()
          this.$swal({
            title: '¡Error!',
            html: this.$t(error.response?.data?.message || error.message),
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: 'Ok',
            confirmButtonColor: '#1374F2',
            showCloseButton: true,
            allowOutsideClick: false
          })
        }
      }
    }
  }
}
</script>
